export default __webpack_public_path__ + "static/media/luciana_souza.ef4adbe8.png";